import { cn, expiryStatus, daysUntilExpiry } from '@/lib/utils'

interface Props {
  expiryDate?: string
  className?: string
}

export default function ExpiryBadge({ expiryDate, className }: Props) {
  const status = expiryStatus(expiryDate)
  const days = daysUntilExpiry(expiryDate)

  if (status === 'none') return null

  const styles: Record<string, string> = {
    expired:  'bg-red-100 text-red-700 border-red-200',
    critical: 'bg-red-50 text-red-600 border-red-200',
    warning:  'bg-amber-50 text-amber-700 border-amber-200',
    upcoming: 'bg-blue-50 text-blue-700 border-blue-200',
    ok:       'bg-green-50 text-green-700 border-green-200',
    none:     '',
  }

  const label =
    status === 'expired'  ? 'Expired' :
    status === 'critical' ? `${days}d left` :
    status === 'warning'  ? `${days}d left` :
    status === 'upcoming' ? `${days}d` :
    `${days}d`

  return (
    <span className={cn(
      'inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border',
      styles[status],
      className
    )}>
      {label}
    </span>
  )
}
